import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ spacing }) => css`
    width: 335px;
    margin-top: ${spacing.xs};
  `,

  containerBox: css`
    display: flex;
    flex-direction: column;
    padding: 0;
  `,

  wrapperData: ({ spacing }) => css`
    display: flex;
    margin-bottom: ${spacing.xxs};
  `,

  wrapperText: ({ spacing, fontSizes, fontWeights }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
      margin: 0 0 0 ${spacing.xxs};
      font-size: ${fontSizes.lg};
      font-weight: ${fontWeights.bold};
    }
    span {
      margin-left: ${spacing.xxs};
      font-size: ${fontSizes.sm};
    }
  `,
})

export default useStyles
